import type { CSSProperties } from 'vue';
import { Module } from 'vuex';
import type { Event, EventPayload } from '@/ts-definitions';
import type { RootStore } from '../rootStore';

export interface NotificationStore {
  open: boolean;
  message?: string;
  customIcon?: any | null;
  messageStyle: CSSProperties;
  color: 'primary' | 'success' | 'warning' | 'danger';
  anchor: {
    vertical: 'top' | 'center' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
}

export type NotificationMutations = EnqueueNotification | CloseNotification;

export type EnqueueNotification = EventPayload<
  'notification/enqueueNotification',
  {
    message: string;
    color?: NotificationStore['color'];
    customIcon?: any;
    messageStyle?: CSSProperties;
  }
>;

type CloseNotification = Event<'notification/closeNotification'>;

export const notificationStore: Module<NotificationStore, RootStore> = {
  namespaced: true,
  state: () => ({
    open: false,
    message: undefined,
    color: 'success',
    customIcon: null,
    messageStyle: {},
    anchor: {
      vertical: 'top',
      horizontal: 'center',
    },
  }),
  mutations: {
    enqueueNotification: (state, { payload }: EnqueueNotification) => {
      state.message = payload.message;
      state.color = payload.color ?? 'success';
      state.customIcon = payload.customIcon;
      state.messageStyle = payload.messageStyle ?? {};
      state.open = true;
    },
    closeNotification: (state) => {
      state.open = false;
      state.message = undefined;
    },
  },
};
